import HelloSign from 'hellosign-embedded';

import config from './config';

export default new HelloSign({ clientId: config.helloSign.clientId });
